import React, { ChangeEvent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { AppState, IPageState } from '../../appredux';
import { ThemeProvider, withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, FormControl, Select, MenuItem, TextField } from '@material-ui/core';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
import theme from '../../themes';
import { normalizeTextSms } from 'pages/helpers';
import moment from 'moment';
import { ManagerService } from 'api';
import { sendErrorLog } from 'common/helpers';
import Loader from 'components/Loader';



interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
    open: boolean,
    closeDialog: () => void,
    mode: number
}

interface DialogState {
    opis: number,
    tresc: string,
    openInfo: boolean,
    openInfoError: boolean,
    ladowanie: boolean
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {
    stylInputaIlePokoi: React.CSSProperties = { padding: "6px 14px", textAlign: "left", fontSize: "15px" };

    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            opis: 1,
            tresc: this.lista()[0].opis,
            openInfo: false,
            openInfoError: false,
            ladowanie: false
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        if(this.props.open !== prevProps.open){
           this.setState({ opis: 1, tresc: this.lista()[0].opis})
        }
    }

    handleChangeOpis = (event: ChangeEvent<{ name?: string | undefined; value: unknown; }>, child: ReactNode) => {
        let val = event.target.value as number
        let tresc =  this.lista().find(x => x.id === val)

         if (tresc?.opis)
             this.setState({ opis: val, tresc: tresc.opis });
         else
              this.setState({opis: val});  
        };

    onChangeTresc = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
        let val = String(event.target.value)
        this.setState({ tresc: val })
    }


    lista = () => {
        let opis = ""
        switch (this.props.mode) {
            case 1:
                opis = " - podoba mi się bo "
                break;
            case 2:
                opis = " - to wymaga poprawy bo "
                break;
            case 3:
                opis = " - mam sugestię aby "
                break;

         default:
             break;
        }

        return [
            {id: 1, opis: "LESKO SKI" + opis},
            {id: 2, opis: "WYCIĄG" + opis},
            {id: 3, opis: "STOK" + opis},
            {id: 4, opis: "JEDZENIE" + opis},
            {id: 5, opis: "WYPOŻYCZALNIA" + opis},
            {id: 6, opis: "NOCLEGI" + opis},
            {id: 7, opis: "OBSŁUGA" + opis},
        ]
    }

    wyslijSms = async () => {
        try {
         
          
            this.setState({ ladowanie: true })
            this.props.closeDialog()
            
            let time =  moment(new Date()).locale(this.props.page.lang).format('YYYY-MM-DD HH:mm')
            //console.log(time)
            let wiadomosc = normalizeTextSms(this.state.tresc) + "****" + time

            let dane = {
              mobileId: "4-FCM-11",
              mobileNr: "0",
              nadawcaId: "lesko-SKI",
              przesylkaId: "0",
              tekst: wiadomosc,
              telNr: "698610243", //606257683
            }

            let res = await ManagerService.smsWyslij({ dane: dane })

            if (res.result[0] > 0) {
              this.setState({ openInfo: true })
            } else {
              this.setState({ openInfoError: true })
            }

            //this.setState({ ...this.state, openSmsInfo: false });
            //this.handleModalClose();
            this.setState({ ladowanie: false })
          

            sendErrorLog("1", "1", 'wyslano opinie')
        } catch (error) {
            console.log(error);
            this.setState({ ladowanie: false})
            await sendErrorLog( "0", "-1", 'vscSms/fcm/smsWyslijPrzesylkaId')
            //await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/fcm/smsWyslijPrzesylkaId", 2))
        }
     
    }

    closeInfo = () => {
        this.setState({openInfo: false})
      }
      closeInfoError = () => {
        this.setState({openInfoError: false})
      }



    render() {
        const classes = this.props.classes;

       
        let lista = this.lista()

       let title = ""
        switch (this.props.mode) {
            case 1:
                title = "to mi się podoba"
                break;
            case 2:
                title = "to wymaga poprawy"
                break;
            case 3:
                title = "mam sugestię aby"
                break;

            default:
                break;
        }
        

        return (
            <>

                {this.state.ladowanie ? <Loader /> : null}

                <Dialog
                    maxWidth="xs"
                    open={this.props.open}
                    onEscapeKeyDown={this.props.closeDialog}
                    onBackdropClick={this.props.closeDialog}
                    fullWidth
                >
                    <DialogTitle disableTypography style={{padding: "16px 24px 0px 24px"}}>
                        <Typography gutterBottom variant="h6" component="h2" color='primary'
                            className={`${classes.headline}`}><b style={{ }}>{title}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>

                    <ThemeProvider theme={theme}>
                        <FormControl //style={{paddingLeft: "24px"}}
                            variant="outlined" margin="dense" fullWidth
                            className={classes.formControl}
                        >
                            <label className={`${classes.label} ${classes.labelColor}`} >{"Nasze pytania"}</label>
                            <Select
                                autoFocus
                                color='primary'
                                value={this.state.opis}
                                onChange={this.handleChangeOpis}

                                classes={{ selectMenu: classes.select,  }}

                                className={classes.inputWidth}
                                variant="outlined"

                            >

                                {lista.map(x => (
                                    <MenuItem value={x.id} key={x.id} className={classes.menuItem}>{x.opis}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>

                            <FormControl //style={{paddingLeft: "24px"}}
                                variant="outlined" margin="dense" fullWidth
                                className={classes.formControl}
                            >
                                    <label className={`${classes.label} ${classes.labelColor}`} >{"Twoja opinia"}</label>

                                    <TextField
                                        id={"1"}
                                        //type={'number'}
                                        color='primary'
                                        multiline
                                        minRows={7}
                                        //rowsMax={7}
                                        className={classes.inputWidth}
                                        //style={this.props.style}
                                      
                                        variant="outlined"
                                        inputProps={{ style: this.stylInputaIlePokoi, }}
                                        InputProps={{ classes: { input: `${classes.textField}` }, }}
                                        //value={capitalizeFirstLetter(this.state.imie)}
                                        value={this.state.tresc}
                                        //disabled={this.props.disabled}
                                        //onKeyDown={this.preventKeys}
                                        onChange={this.onChangeTresc}
                                    />
                            </FormControl>

                        </ThemeProvider>

                       
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.props.closeDialog}>
                            <b>wróć</b>
                        </Button>
                        <Button variant="contained" color="primary" size="small" className={classes.button}
                            onClick={this.wyslijSms}
                        >
                            <b>wyślij</b>
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                      //disableEscapeKeyDown
                      maxWidth="xs"
                      open={this.state.openInfo}
                      onEscapeKeyDown={this.closeInfo}
                      onBackdropClick={this.closeInfo}
                      fullWidth
                  >
                      <DialogTitle disableTypography >
                          <Typography gutterBottom variant="h6" component="h2"
                              className={`${classes.primary}`}>
                              <b style={{ textTransform: "lowercase" }}>{"sukces"}</b>
                          </Typography>
                          <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                      </DialogTitle>
                      <DialogContent style={{paddingBottom: "20px"}}>
                          <DialogContentText  color='primary'>
                              {"Sms został wysłany"}
                          </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                          <Button variant="outlined" color="primary" size="small"
                              onClick={this.closeInfo}>
                              <b>{"wróć"}</b>
                          </Button>
                      </DialogActions> 
                  </Dialog>
                  <Dialog
                      //disableEscapeKeyDown
                      maxWidth="xs"
                      open={this.state.openInfoError}
                      onEscapeKeyDown={this.closeInfoError}
                      onBackdropClick={this.closeInfoError}
                      fullWidth
                  >
                      <DialogTitle disableTypography >
                          <Typography gutterBottom variant="h6" component="h2" color="error"  >
                              <b style={{ textTransform: "lowercase" }}>{"niepowodzenie"}</b>
                          </Typography>
                          <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                      </DialogTitle>
                      <DialogContent style={{paddingBottom: "20px"}}>
                          <DialogContentText  >
                              {"Sms nie został wysłany"}
                          </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                          <Button variant="outlined" color="secondary" size="small"
                              onClick={this.closeInfoError}>
                              <b>{"wróć"}</b>
                          </Button>
                      </DialogActions> 
                  </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      paddingLeft: {
        paddingLeft: "20px"
      },
      headline: {
        lineHeight: "20px",
      },
      dialogContentText: {
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
      },
      button: {
        textTransform: "none" as "none"
    },

    label: {
        //color: theme.palette.primary.main,
        //color: theme.palette.text.secondary,
        //fontFamilly: "sans-serif",
        //fontSize: "small"
        fontSize: "13px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: "bold" as "bold", 
        //fontWeight: theme.typography.body2.fontWeight,
        //paddingLeft: "20px",
        //padding: "7px 0 4px",
        marginRight: "10px",
        width: "110px",
       // width: "calc(100% + -85px)",
        display: "inline-block" as "inline-block",
        //"@media (max-width: 600px)": {
        //  width: "90px",
        //}

      },
     labelColor: {
        //color: theme.palette.text.secondary,
        color: theme.palette.primary.main,
      },
      formControl: {
        //display: "block",
        //paddingBottom: "35px"
        marginTop: "0px", //4px
        
        //display: "inline-flex" as "inline-flex",
        //display: "flex" as "flex",
        //alignItems: "center" as "center",
        //flexDirection: "row" as "row",   
    },
    menuItem: {
        fontSize: "15px !important"  
      },
      select: {
        //color: "rgb(0, 0, 0)",
        color: theme.palette.primary.main,
        //color: orangeTheme.palette.primary.main,
        //color: 'seagreen',
        padding: "8px 14px", fontSize: "15px", 
        //padding: "8px 14px",
        //fontSize: '16px',
        float: "left" as "left",
        textAlign: "left" as "left",
        //fontWeight: "normal" as "normal", 
        //fontWeight: "bold" as "bold", 
        //width: "120px"
        //width: "clac(100% + - 164px)"
        
      },
      inputWidth: {
        //width: "15%",
        width: "100%",
        marginBottom: "12px"
        //display: "inline-flex" as "inline-flex",
        //"@media (max-width: 600px)": {
        //  width: 'calc(100% + -100px)', 
        //}
      },
      textField: {
        //color: "rgb(0, 0, 0)",
        //color: theme.palette.primary.main,
        color: theme.palette.primary.main,
        //color: 'seagreen',
        padding: "8px 14px",
        fontSize: '16px',
        float: "left" as "left",
        textAlign: "left" as "left",
        fontWeight: "normal" as "normal", 
        //width: "120px"
        
      },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

